import {
  GET_SCALPCAMERA_PIN_CODE,
  RESET_SCALPCAMERA_DIAGNOSIS,
  GET_SCALPCAMERA_DIAGNOSIS_RESULT,
  SET_SCALPCAMERA_PIN_CODE,
  RESET_SCALPCAMERA_PIN_CODE,
  UPDATE_SCALP_CAMERA_STATUS,
} from '../constants';

const defaultState = {
  pinCode: {
    pin: undefined,
    application: undefined,
    imageUrl: undefined,
    success: undefined,
  },
  diagnosisResults: {
    pin: undefined,
    application: undefined,
    imageUrl: undefined,
    diagnosis_results: {},
    success: undefined,
  },
  scalpCameraStatus: {
    hasBeenCalledApp: '',
  },
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case `${GET_SCALPCAMERA_PIN_CODE}_PENDING`:
      return state;
    case `${GET_SCALPCAMERA_PIN_CODE}_FULFILLED`:
      return {
        ...state,
        pinCode: action.payload,
      };
    case `${GET_SCALPCAMERA_PIN_CODE}_REJECTED`:
      return state;
    case RESET_SCALPCAMERA_DIAGNOSIS:
      return defaultState;

    case `${GET_SCALPCAMERA_DIAGNOSIS_RESULT}_PENDING`:
      return state;
    case `${GET_SCALPCAMERA_DIAGNOSIS_RESULT}_FULFILLED`: {
      return {
        ...state,
        diagnosisResults: action.payload,
      };
    }
    case `${GET_SCALPCAMERA_DIAGNOSIS_RESULT}_REJECTED`: {
      return state;
    }
    case SET_SCALPCAMERA_PIN_CODE:
      return {
        ...state,
        pinCode: action.payload,
      };
    case RESET_SCALPCAMERA_PIN_CODE:
      return {
        ...state,
        pinCode: defaultState.pinCode,
      };
    // スカルプカメラアプリ起動状況を更新する (起動成功/失敗)
    case UPDATE_SCALP_CAMERA_STATUS:
      const { hasBeenCalledApp } = action.payload;
      return {
        ...state,
        scalpCameraStatus: { hasBeenCalledApp },
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/scalpCameraDiagnosis.js